import { money } from '../format';
import { useShop } from '../shop';

/** A price, or the right words when the shop hides prices until sign-in. */
export function Price({ value, from = false, className = '' }: { value: number | null; from?: boolean; className?: string }) {
  const { shop, session } = useShop();
  if (!session.pricesShown) return <span className={`text-sm text-stone-500 ${className}`}>Price on sign-in</span>;
  if (value === null) return <span className={`text-sm text-stone-500 ${className}`}>Ask for price</span>;
  return (
    <span className={`font-semibold text-stone-900 dark:text-stone-100 ${className}`}>
      {from && <span className="mr-1 text-xs font-normal text-stone-500">from</span>}
      {money(value, shop.currency)}
    </span>
  );
}
